export * from './gql'
export * from './railsContext'

import { createContext } from 'react'

import { Account, Cart, CheckoutPayload, Location, Shop, User } from 'Types'

interface LiquidVariables {
  account: Account
  authenticityToken: string
  cart: Cart
  currentLocation: Location
  googlePlacesApiKey: string
  locationCountryIsoCodes: string[]
  shop: Shop
  user: User | null
}

interface AppContext extends LiquidVariables {
  checkout?: CheckoutPayload
  onCheckout(checkout?: CheckoutPayload): void
  setAppValues?: React.Dispatch<React.SetStateAction<LiquidVariables>>
}

export const AppContext = createContext({} as AppContext)

export const OTHER = 'other'
export const EMAIL_PATTERN =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
export const COUNTRY_STATE_ISO_CODE_REGEXP = /^([A-Z]{1,5}|\d{1,5})$/
export const DEFAULT_COUNTRY_ISO_CODE = 'CA'
export const CURRENT_MILLENNIUM = 2000
export const MIN_MONTH_NUMBER = 1
export const MAX_MONTH_NUMBER = 12
